// Botón "Añadir" de la fila de segundas piezas del cart drawer (snippets/oe-2x1-cart.liquid).
// Se carga siempre con el drawer porque la fila aparece al actualizarse el carrito sin recargar.
import { CartAddEvent } from '@theme/events';

if (!customElements.get('oe-cart-upsell')) {
  customElements.define(
    'oe-cart-upsell',
    class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      onClick = async (event) => {
        const button = event.target.closest('button[data-variant-id]');
        if (!button || button.disabled) return;

        // Con tallas o colores se añade la opción elegida en el selector de esa misma pieza
        const select = button.closest('li')?.querySelector('select');
        const variantId = Number(select?.value || button.dataset.variantId);

        const sectionId = this.closest('cart-items-component')?.dataset.sectionId;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');

        try {
          const response = await fetch(Theme.routes.cart_add_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: variantId, quantity: 1 }],
              ...(sectionId && { sections: sectionId, sections_url: window.location.pathname }),
            }),
          });
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || data.message);

          const cart = await fetch(`${Theme.routes.cart_url}.js`).then((r) => r.json());
          document.dispatchEvent(
            new CartAddEvent(cart, 'oe-cart-upsell', {
              source: 'oe-cart-upsell',
              itemCount: cart.item_count,
              variantId: String(variantId),
              sections: data.sections,
            })
          );
        } catch (error) {
          console.error(error);
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      };
    }
  );
}
